import React, { useEffect, useState } from 'react';
import {
  Paper,
  CircularProgress,
  Button,
  MenuItem,
  TextField,
  Grid
} from '@material-ui/core';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import { getClientsAction } from 'src/store/actions/ClientManagerActions';
import { getAPIAccessKeyAction } from 'src/store/actions/AccessKeyActions';
import {
  getRouteCategory,
  getRoutes
} from 'src/store/actions/RouteManagerActions';
import { getRouteCategoryAction } from 'src/store/actions/RouteCategoryActions';

function GraphFilter({ handleFilter, type, filterLoader }) {
  const dispatch = useDispatch();
  const profile = JSON.parse(sessionStorage.getItem('profile'));
  const clients = useSelector((state) => state.Clients.clients);
  const accessKeyData = useSelector((state) => state.AccessKey.accessKeyList);
  const routeData = useSelector((state) => state.Route.routeData);
  const routeCategoryData = useSelector(
    (state) => state.RouteCategories.routeCategories
  );
  const millisecondsPerDay = 24 * 60 * 60;
  const [timespan, setTimespan] = useState(millisecondsPerDay);
  const [fromDate, setFromDate] = useState(
    moment().subtract(1, 'd').format('YYYY-MM-DD')
  ); // gets the last sunday as default fromDate value
  const [toDate, setToDate] = useState(moment().format('YYYY-MM-DD'));

  const {
    handleSubmit,
    handleChange,
    values,
    errors,
    touched,
    handleBlur
  } = useFormik({
    initialValues: {
      issuerID: '',
      apiAccessKeyID: '',
      categoryID: '',
      routeID: '',
      unitTimespan: '',
      from: '',
      to: ''
    },
    onSubmit: (values) => {
      const fdate = moment(fromDate).unix();
      const tdate = moment(toDate).unix();
      const tspan = values.unitTimespan * timespan;

      handleFilter(
        { ...values, to: tdate, from: fdate, unitTimespan: tspan },
        type
      );
    }
  });

  useEffect(() => {
    dispatch(getClientsAction());
    dispatch(getAPIAccessKeyAction());
    dispatch(getRouteCategoryAction('', profile));
    dispatch(getRoutes());
  }, []);

  return (
    <Paper
      elevation={3}
      style={{ width: '100%', padding: 10, marginBottom: 20 }}
    >
      <form onSubmit={handleSubmit}>
        <Grid container spacing={2}>
          {profile.super == 1 && (
            <Grid item sm={3}>
              <TextField
                error={Boolean(touched.issuerID && errors.issuerID)}
                helperText={touched.issuerID && errors.issuerID}
                fullWidth
                size="small"
                id="issuerID"
                select
                margin="normal"
                name="issuerID"
                label="Client"
                variant="outlined"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.issuerID}
              >
                <MenuItem value={'-'}>All</MenuItem>
                {clients.map((option) => (
                  <MenuItem key={option.issuerID} value={option.issuerID}>
                    {option.fullname}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
          )}
          <Grid item sm={3}>
            <TextField
              error={Boolean(touched.apiAccessKeyID && errors.apiAccessKeyID)}
              helperText={touched.apiAccessKeyID && errors.apiAccessKeyID}
              fullWidth
              size="small"
              id="apiAccessKeyID"
              select
              margin="normal"
              name="apiAccessKeyID"
              label="API Access Key"
              variant="outlined"
              onBlur={handleBlur}
              onChange={handleChange}
              value={values.apiAccessKeyID}
            >
              <MenuItem value="">All</MenuItem>
              {accessKeyData.map((option, idx) => (
                <MenuItem value={option.id}>{option.name}</MenuItem>
              ))}
            </TextField>
          </Grid>

          <Grid item sm={3}>
            <TextField
              size="small"
              error={Boolean(touched.categoryID && errors.categoryID)}
              helperText={touched.categoryID && errors.categoryID}
              fullWidth
              select
              margin="normal"
              name="categoryID"
              label="Route Category"
              variant="outlined"
              onBlur={handleBlur}
              onChange={handleChange}
              value={values.categoryID}
            >
              <MenuItem value={'-'}>All</MenuItem>
              {routeCategoryData.map((option) => (
                <MenuItem key={option.id} value={option.id}>
                  {option.name}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item sm={3}>
            <TextField
              size="small"
              error={Boolean(touched.routeID && errors.routeID)}
              helperText={touched.routeID && errors.routeID}
              fullWidth
              select
              margin="normal"
              name="routeID"
              label="Route"
              variant="outlined"
              onBlur={handleBlur}
              onChange={handleChange}
              value={values.routeID}
            >
              <MenuItem value={'-'}>All</MenuItem>
              {routeData.map((option) => (
                <MenuItem key={option.routeID} value={option.routeID}>
                  {option.name}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item sm="3">
            <TextField
              error={Boolean(touched.userID && errors.userID)}
              fullWidth
              helperText={touched.userID && errors.userID}
              label="UserID"
              margin="dense"
              name="userID"
              onBlur={handleBlur}
              onChange={handleChange}
              type="text"
              value={values.userID}
              variant="outlined"
              size="small"
            />
          </Grid>

          {type == 'Date' && (
            <Grid item sm={3}>
              <TextField
                size="small"
                error={Boolean(touched.unitTimespan && errors.unitTimespan)}
                helperText={touched.unitTimespan && errors.unitTimespan}
                fullWidth
                margin="normal"
                name="unitTimespan"
                label="Day Range"
                type="number"
                id="unitTimespan"
                defaultValue={timespan}
                variant="outlined"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.unitTimespan}
              />
            </Grid>
          )}
          <Grid item sm={3}>
            <TextField
              size="small"
              margin="normal"
              id="fromDate"
              label="From Date"
              type="date"
              fullWidth
              defaultValue={''}
              onChange={(e) => setFromDate(e.target.value)}
              onBlur={handleBlur}
              error={Boolean(touched.from && errors.from)}
              helperText={touched.from && errors.from}
              InputLabelProps={{
                shrink: true
              }}
            />
          </Grid>

          <Grid item sm={3}>
            <TextField
              size="small"
              margin="normal"
              id="toDate"
              label="To Date"
              type="date"
              fullWidth
              defaultValue={toDate}
              //   value={toDate}
              onChange={(e) => setToDate(e.target.value)}
              onBlur={handleBlur}
              error={Boolean(touched.to && errors.to)}
              helperText={touched.to && errors.to}
              InputLabelProps={{
                shrink: true
              }}
            />
          </Grid>
          <Grid sm={3}>
            <Button
              disabled={filterLoader}
              variant="contained"
              color="primary"
              style={{ marginLeft: 10 }}
              onClick={handleSubmit}
            >
              {filterLoader && <CircularProgress size="1.5rem" />}
              Filter
            </Button>
          </Grid>
        </Grid>
      </form>
    </Paper>
  );
}

export default GraphFilter;
